// extracted by mini-css-extract-plugin
export default {"imgStyleRight":"Hero_imgStyleRight__OyyAD","slide":"Hero_slide__rdCI1","h3Style":"Hero_h3Style__Ar11e","h5Style":"Hero_h5Style__5iqm2"};